import {getPrivateAxios} from '../../libs';
import {Collection} from './types';

/**
 *
 * @param guide
 */
export const fetchCollectionGuidesUpdate = async (
  collectionId: string,
  guides: {guideId: string; position: number}[],
) => {
  const {data} = await getPrivateAxios().patch<Collection>(`/collections/${collectionId}/guides`, {
    guides,
  });
  return data;
};
